import { WORK_WAS_KEPT } from '../api/waitingChanges';

/** The server's answer to "Update this ad" / "Update all". */
export interface LiveAdsUpdateAnswer {
  data?: { updateLiveAds?: { updated: number; kept?: number } } | null;
}

type SendUpdate = (options: {
  variables: { vacancyId: number; input: { ad_variant_ids?: number[] } };
}) => Promise<LiveAdsUpdateAnswer>;

/**
 * SYM-6757 (Steven, 3 Nov 2026). On a running campaign the server KEEPS the
 * update for "Publish changes" instead of carrying it out. The sidebar then
 * counts it, and the open ad is drawn again with the campaign's current
 * details: what the screen shows is what goes live.
 */
export const sendLiveAdsUpdate = async (
  update: SendUpdate,
  vacancyId: number,
  redraw: () => void,
  ids?: number[]
): Promise<LiveAdsUpdateAnswer> => {
  const answer = await update({
    variables: { vacancyId, input: ids ? { ad_variant_ids: ids } : {} },
  });
  if ((answer?.data?.updateLiveAds?.kept ?? 0) > 0) {
    window.dispatchEvent(new CustomEvent(WORK_WAS_KEPT));
    redraw();
  }
  return answer;
};
